import Vue from 'vue'
import Router from 'vue-router'
import TeamSettingView from './views/TeamSettingView.vue'
import CalendarSettingView from './views/CalendarSettingView.vue'
import ConsoleView from './views/ConsoleView.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/team/:ownerId',
      name: 'team',
      component: TeamSettingView,
      props: true
    },
    {
      path: '/cal/:ownerId',
      name: 'cal',
      component: CalendarSettingView,
      props: true
    },
    {
      path: '/console/:ownerId',
      name: 'console',
      component: ConsoleView,
      props: true
    }
  ]
})
